export const tableSize = 6;
